import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, Catalogue, IBaseProperties } from "../base";
import { Product } from "../products/product";
export const OrderItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      deliveryDate: types.maybeNull(types.string),
      unitPrice: types.maybeNull(types.number),
      quantityUpper: types.maybeNull(types.number),
      quantityStandard: types.maybeNull(types.number),
      quantityLower: types.maybeNull(types.number),
      deliveredQuantity: types.maybeNull(types.number),
      statusId: types.maybeNull(types.string),
      status: types.maybeNull(Catalogue),
      isCompensating: types.optional(types.boolean, false),
      compensatingQuantity: types.maybeNull(types.number),
      compensatingReason: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IOrderItem extends Instance<typeof OrderItem> {}
export interface IOrderItemProperties extends SnapshotIn<typeof OrderItem> {}

export interface IAddOrderItem
  extends Omit<
    IOrderItemProperties,
    | "status"
    | "product"
    | "status"
    | "deliveredQuantity"
    | "statusId"
    | keyof IBaseProperties
  > {}
export interface IUpdateOrderItem
  extends Omit<
    IOrderItemProperties,
    "status" | "product" | "status" | "deliveredQuantity" | "statusId"
  > {}
export interface IUpdateStatus
  extends Pick<IOrderItemProperties, "id" | "statusId" | "deliveredQuantity"> {}

export interface IUpdateUnitPrice
  extends Pick<IOrderItemProperties, "id" | "unitPrice"> {}
